import { BuildInAppToolId } from '../types/appTools';
import MessagesAnimatedIcon from '../icons/animation/MessagesAnimatedIcon.json';
import SessionChatAnimatedIcon from '../icons/animation/SessionChatAnimatedIcon.json';
import SupportChatAnimatedIcon from '../icons/animation/SupportChatAnimatedIcon.json';
import MeetingsAnimatedIcon from '../icons/animation/MeetingsAnimatedIcon.json';

export const AppToolbarAnimatedIconConfig = {
    [BuildInAppToolId.Messages]: MessagesAnimatedIcon,
    [BuildInAppToolId.SessionChats]: SessionChatAnimatedIcon,
    [BuildInAppToolId.SupportChat]: SupportChatAnimatedIcon,
    [BuildInAppToolId.Meetings]: MeetingsAnimatedIcon,
};
